export default {
	// spread_from/spread_to: a path's two spreads (0 = no path; never exposed).
	ids: ['color', 'color_b', 'spread', 'repeat', 'wash', 'ground', 'spread_from', 'spread_to'],
	glsl: `
#include "hsl"

#include "palette"

// repeat between 0 (ramp) and 1 (mirror) blends the two palettes. A path between two spreads moves each element once, from its entry at spread_from to its entry at spread_to, in HSL; q is spread's own progress between them. Tweening spread itself would rebuild the palette at every whole count crossed.
// ⚠️ Two palette call sites, each with a constant mirror, the spread ends looped: every call site inlines palette and bandColor's are many, so one spreadPalette call per end took minutes to link with spread, repeat and the path free.
vec3 repeatPalette(float big, float small, float blur) {
	bool path = uSpreadFrom > 0.0 && uSpreadTo != uSpreadFrom;
	float q = path ? clamp((uSpread - uSpreadFrom) / (uSpreadTo - uSpreadFrom), 0.0, 1.0) : 0.0;
	int spreads = q > 0.0 && q < 1.0 ? 2 : 1;
	float first = path ? (q >= 1.0 ? uSpreadTo : uSpreadFrom) : uSpread;
	float r = clamp(uRepeat, 0.0, 1.0);
	vec3 from = vec3(0.0);
	vec3 to = vec3(0.0);
	for (int i = 0; i < spreads; i++) {
		float spread = i == 0 ? first : uSpreadTo;
		vec3 c = r < 1.0 ? (1.0 - r) * palette(uColorA, uColorB, big, small, spread, 0.0, blur) : vec3(0.0);
		if (r > 0.0) c += r * palette(uColorA, uColorB, big, small, spread, 1.0, blur);
		if (i == 0) from = c;
		else to = c;
	}
	return spreads == 2 ? mixHsl(from, to, q) : from;
}

// One palette colour per element; turns: the elements a carried travel folded away, so the colour keeps its place across the fold.
vec3 bandColor(float idx, float turns, float blur) {
	return repeatPalette(uWashTurns + turns, idx + uWash, blur);
}
`,
	// SCAFFOLD: the band index as a code, whole neighbours apart and smooth along a continuous index, so the palette draws no line.
	scaffold: {
		at: 'return repeatPalette(uWashTurns + turns, idx + uWash, blur);',
		glsl: 'return vec3(0.5 + 0.5 * cos(0.5 * TAU * idx), 0.5 + 0.5 * cos(0.25 * TAU * idx), 1.0);',
	},
}
